import React from 'react';
import { CheckCircle } from 'lucide-react';

const PHASES = [
  { num: 1, label: 'State of Field' },
  { num: 2, label: 'Triage' },
  { num: 3, label: 'Density' },
  { num: 4, label: 'Resolution' },
  { num: 5, label: 'Closing' }
];

export default function SessionPhaseBar({ currentPhase, session }) {
  return (
    <div className="flex items-center gap-1 w-full">
      {PHASES.map((phase, i) => {
        const isCompleted = session?.[`phase${phase.num}_completed_at`];
        const isCurrent = currentPhase === phase.num;
        
        return (
          <React.Fragment key={phase.num}>
            <div className="flex flex-col items-center flex-1">
              <div className={`
                w-full h-2 rounded-full transition-all
                ${isCompleted ? 'bg-emerald-500' : isCurrent ? 'bg-amber-500 animate-pulse' : 'bg-slate-700'}
              `} />
              <div className="flex items-center gap-1 mt-1.5">
                {isCompleted && <CheckCircle className="w-3 h-3 text-emerald-400" />}
                <span className={`text-[10px] font-medium ${isCompleted ? 'text-emerald-300' : isCurrent ? 'text-amber-300' : 'text-slate-400'}`}>
                  {phase.num}. {phase.label}
                </span>
              </div>
            </div>
            {i < PHASES.length - 1 && (
              <div className={`w-4 h-0.5 mt-[-10px] ${isCompleted ? 'bg-emerald-500' : 'bg-slate-700'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}